var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.06641 22.9531V5.07812C4.06641 3.95632 4.97585 3.04688 6.09766 3.04688H3.05078C1.92897 3.04688 1.01953 3.95632 1.01953 5.07812V22.9531C1.01953 24.075 1.92897 24.9844 3.05078 24.9844H6.09766C4.97585 24.9844 4.06641 24.0749 4.06641 22.9531Z",
    fill: "url(#paint0_linear_181_674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3008 3.04688C20.4226 3.04688 21.332 3.95632 21.332 5.07812V22.9531C21.332 24.0749 20.4226 24.9844 19.3008 24.9844H3.05078C1.92897 24.9844 1.01953 24.0749 1.01953 22.9531V5.07812C1.01953 3.95632 1.92897 3.04688 3.05078 3.04688",
    stroke: "url(#paint1_linear_181_674)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14453 3.04688H13.207M11.1758 1.01562V3.04688",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1758 15.0312H17.2695M11.1758 21.125H17.2695M5.08203 14.0156L6.09766 15.0312L8.12891 13M11.1758 8.9375H17.2695M5.08203 7.92188L6.09766 8.9375L8.12891 6.90625M5.08203 20.1094L6.09766 21.125L8.12891 19.0938M3.05078 3.04688H5.08203M19.3008 3.04688H17.2695",
    stroke: "url(#paint2_linear_181_674)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_674",
    x1: 1.01953,
    y1: 3.04687,
    x2: 11.976,
    y2: 6.53853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_674",
    x1: 1.38294,
    y1: 0.580212,
    x2: 26.5508,
    y2: 22.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_674",
    x1: 3.34151,
    y1: 1.01416,
    x2: 23.9867,
    y2: 18.4153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.1b6446497d3c0473b787601d59b6f157.svg";
export { ForwardRef as ReactComponent };